import React from "react";
import { useParams } from "react-router-dom";
import parse from "html-react-parser";
import axios from "axios";
import { useState } from "react";
import { useEffect } from "react";
import expDataTemplate from "../../utils/expData.template.json";
import BounceLoader from "react-spinners/BounceLoader";
const GIST_ID = "52552698c6328f5d5fe22567e535dd06";

const simulationOnClick = () => {
  window.location.href += "/simulation";
};

const testOnClick = () => {
  window.location.href += "/test";
};

export default function Experiment() {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [exptContent, setExptContent] = useState(expDataTemplate);
  const axiosConfig = {
    method: "get",
    url: `https://api.github.com/gists/${GIST_ID}`,
    headers: {},
  };

  useEffect(() => {
    axios(axiosConfig)
      .then((res) => {
        console.log(JSON.parse(res.data.files["db.json"].content));
        setExptContent(JSON.parse(res.data.files["db.json"].content));
        setIsLoading(false);
      })
      .catch((err) => {
        alert("Error fetching data from server :(");
        console.error(err);
      });
    //eslint-disable-next-line
  }, []);

  return (
    <div className="flex flex-col justify-center items-center p-10">
      {/* <!-- Page content here --> */}
      <BounceLoader loading={isLoading} className="" color="#36d7b7" />
      {!isLoading && (
        <>
          {parse(exptContent.expts[Number(id) - 1].pageContent)}
          <div className="btn-container m-2 flex flex-col md:flex-row justify-center align-center gap-8 sm:gap-3">
            <button
              onClick={simulationOnClick}
              className="btn btn-info shadow-xl h-auto"
            >
              Go to Simulation
            </button>
            <button
              onClick={testOnClick}
              className="btn btn-info shadow-xl h-auto"
            >
              Test Your Understanding
            </button>
          </div>
        </>
      )}
      {isLoading && (
        <div className="flex flex-col justify-center items-center">
          <h1 className="text-2xl font-bold">Loading...</h1>
        </div>
      )}
    </div>
  );
}
